import React from 'react';
import { Info } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

// Translations for the warning banner - more subtle professional disclaimer
const translations: Record<string, string> = {
    en: 'Calculation assistance tool — Results require verification by a qualified professional before implementation.',
    tr: 'Hesaplama yardımcı aracı — Sonuçlar uygulanmadan önce yetkili bir profesyonel tarafından doğrulanmalıdır.',
    es: 'Herramienta de asistencia para cálculos — Los resultados requieren verificación profesional.',
    de: 'Berechnungshilfsmittel — Ergebnisse erfordern professionelle Überprüfung vor der Umsetzung.',
    zh: '计算辅助工具 — 结果需在实施前经专业人员验证。',
    ja: '計算支援ツール — 結果は実装前に専門家の検証が必要です。'
};

/**
 * Subtle professional disclaimer displayed in the footer.
 * Non-intrusive but present for legal/safety purposes.
 * Supports multiple languages based on the current language setting.
 */
const CalculationWarningBanner: React.FC = () => {
    const { lang } = useLanguage();

    // Get translation for current language (fallback to English)
    const text = translations[lang] || translations.en;

    return (
        <p className="inline-flex items-center justify-center gap-2 text-xs text-gray-500 dark:text-gray-400">
            <Info className="w-3.5 h-3.5 flex-shrink-0 opacity-60" />
            <span>{text}</span>
        </p>
    );
};

export default CalculationWarningBanner;
